import { StepBase } from './StepBase';
import { PageStepType } from './PageTypes';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { DataRecord } from '../utils/DataRecord';
import { DataSet } from '../utils/DataSet';

interface callbackRow
{
	(record: DataRecord): Promise<any>;
}

export class StepLoop extends StepBase
{
	// The actual data that will be used to output the table
	dataset: DataSet = new DataSet();

	// Reference to the logic engine
	logicRef: LogicEngine | undefined;

	// Callback function for each record to pre-process it before adding to the data set
	evRecordCallback: callbackRow | undefined;

	// Optional settings from the "Option"
	listOptions: { [keyName: string]: string } = {};

	/** Add a column to the list of tabs we're tracking in this holder */
	async addOption(step: PageStepType)
	{
		if (!this.logicRef)
			throw "Exception: should not happen but logicRef in StepTabs is null";

		// Key is the configuration lookup key
		let key = step.step_option ? step.step_option : "";
		key = key.toLowerCase().trim();

		if (this.dataset.checkDatasetOption(step))
			return true;

		// Value from the text_en column
		let value = step.text_en ? this.logicRef.processTextReplacement(step.text_en) : (step.option_1 ? step.option_1 : "");
		this.listOptions[key] = value;
	}

	/** At the end of the loop, make the callback to page engine to execute all the commands */
	async processEndLoop(logic: LogicEngine)
	{
		if (!this.logicRef) throw 'Missing LogicRef at StepLoop processEndLoop()';

		for (const row of this.dataset.getRecords())
		{
			if (LogicEngine.debugOutput)
				console.log("StepLoop Execute Row:", row.data);

			this.logicRef?.import(row.data);

			// Import by table name and participant ID if available
			if (this.dataset.tableDef && this.dataset.tableDef.tableName)
			{
				const tableName = this.dataset.tableDef.tableName;
				// for (const key of Object.keys(row.data))
				// {
				// 	this.logicRef.fnIndexReset(tableName, key, row.data[key]);
				// }

				// if (row.data["participant_id"])
				// {
				// 	for (const key of Object.keys(row.data))
				// 	{
				// 		this.logicRef.fnIndexReset(row.data["participant_id"], key, row.data[key]);
				// 	}
				// }

				// if (row.data["uuid"])
				// {
				// 	for (const key of Object.keys(row.data))
				// 	{
				// 		this.logicRef.fnIndexReset(row.data["uuid"], key, row.data[key]);
				// 	}
				// }
			}

			if (this.evRecordCallback)
			{
				let obj = await this.evRecordCallback(row);
				if (obj && typeof obj === 'object')
				{
					this.logicRef?.import(obj);
				}
			}
		}
	}

	/**
	 *  Process the data type here.
	 *  Load the data related to the Query data type.
	 */

	async processStep(logic: LogicEngine): Promise<boolean>
	{
		this.logicRef = logic;
		this.dataset.logicRef = logic;

		await super.processStep(logic);

		this.dataset.setOptions(this.option_1);

		if (this.options.checkOption('Counter'))
		{
			// Create a record based on start and end value
			this.dataset.generateDatasetFromCounter(this.text);
			return true;
		}

		if (this.options.checkOption('List'))
		{
			this.dataset.generateDatasetFromList(this.text);
			return true;
		}

		if (this.options.checkOption('Query'))
		{
			await this.dataset.generateDatsetFromQuery(this.text);
			return true;
		}

		if (this.options.checkOption('QueryGroup'))
		{
			await this.dataset.generateDatasetFromGroupBy(this.text, this.field_id);
			return true;
		}

		// TODO: Handle other types of data
		console.error('StepLoop unknown table data source');
		return false;
	}
}
